package com.schoolconnect.app.feature.reports

import com.schoolconnect.app.datasource.network.request.AcademicReportCriteriaType
import com.schoolconnect.app.datasource.network.request.AttendanceReportCriteriaType
import com.schoolconnect.app.datasource.network.request.AttendanceReportStatus
import com.schoolconnect.app.datasource.network.request.CombinedPerformanceCriteriaRequest
import com.schoolconnect.app.datasource.network.request.CombinedReportMatchType
import com.schoolconnect.app.datasource.network.request.ReportPercentageOperator
import com.schoolconnect.app.datasource.network.request.StaffReportViewBy

enum class StaffReportType {
    ATTENDANCE,
    ACADEMIC,
    COMBINED
}

data class StaffReportsQuery(
    val type: StaffReportType,
    val viewBy: StaffReportViewBy,
    val classIds: List<String>,
    val studentId: String?,
    val examIds: List<String>,
    val fromDate: String,
    val toDate: String,
    val attendanceCriteriaType: AttendanceReportCriteriaType? = null,
    val attendanceOperator: ReportPercentageOperator? = null,
    val attendanceValues: List<Double>? = null,
    val attendanceStatus: AttendanceReportStatus? = null,
    val academicCriteriaType: AcademicReportCriteriaType? = null,
    val academicOperator: ReportPercentageOperator? = null,
    val academicValues: List<Double>? = null,
    val categoryFilter: String? = null,
    val combinedCriteria: List<CombinedPerformanceCriteriaRequest> = emptyList(),
    val matchType: CombinedReportMatchType = CombinedReportMatchType.ALL
)

data class StaffReportSummaryItem(
    val title: String,
    val value: String,
    val detail: String
)

data class StaffReportResultUi(
    val title: String,
    val headers: List<String>,
    val rows: List<List<String>>,
    val summary: List<StaffReportSummaryItem>,
    val totalCount: Int
)
